import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RecentArticlesComponent } from './recent-articles.component'
import { SharedModule } from '../shared/shared.module'
import { PipesModule } from '../../pipes/pipes.module'



@NgModule({
  declarations: [RecentArticlesComponent],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule
  ],
  exports: [RecentArticlesComponent]
})
export class RecentArticlesModule { }
